export const EMPLOYEE_STATUS_TODO = 'Not Started'
export const EMPLOYEE_STATUS_DONE = 'Completed'
export const EMPLOYEE_STATUS_UNFINISHED = 'Started'
export const EMPLOYEE_STATUS_REQUESTED = 'Requested'
export const EMPLOYEE_STATUS_SKIPPED = 'Skipped'

export const AVAILABLE_EMPLOYEE_STATUSES = [
  EMPLOYEE_STATUS_TODO,
  EMPLOYEE_STATUS_UNFINISHED,
  EMPLOYEE_STATUS_DONE,
  EMPLOYEE_STATUS_REQUESTED,
  EMPLOYEE_STATUS_SKIPPED,
]

export const EMPLOYEE_HIGHLIGHT_ROCKSTAR = '10x'
export const EMPLOYEE_HIGHLIGHT_GROWTH_TALENT = '9x'
export const EMPLOYEE_HIGHLIGHT_FLIGHT_RISK = 'flight-risk'

export const AVAILABLE_EMPLOYEE_HIGHLIGHTS = [
  { label: EMPLOYEE_HIGHLIGHT_ROCKSTAR, value: EMPLOYEE_HIGHLIGHT_ROCKSTAR },
  { label: EMPLOYEE_HIGHLIGHT_GROWTH_TALENT, value: EMPLOYEE_HIGHLIGHT_GROWTH_TALENT },
]

export const EMPLOYEE_HIGHLIGHT_TRIGGER_CRITERIA = [
  {
    question: 'Retention at Risk',
    value: 'High',
    result: EMPLOYEE_HIGHLIGHT_FLIGHT_RISK,
  },
  {
    question: 'Talent Category',
    value: 'Top (10X)',
    result: EMPLOYEE_HIGHLIGHT_ROCKSTAR,
  },
  {
    question: 'Talent Category',
    value: 'Growth (9X)',
    result: EMPLOYEE_HIGHLIGHT_GROWTH_TALENT,
  },
]

export const EMPLOYEE_HIGHLIGHT_ICON_MAP: Record<string, string> = {
  [EMPLOYEE_HIGHLIGHT_ROCKSTAR]: '🚀',
  [EMPLOYEE_HIGHLIGHT_GROWTH_TALENT]: '📈',
}

export const ALERT_TYPE_MAPPING = {
  ten_x: '10x',
  nine_x: '9x',
}

export const ConstantIDs = {
  REVIEW_ID_PLACEHOLDER: 'reviewId',
  REVIEW_ID_PATH_PLACEHOLDER: ':reviewId',
  EMPLOYEE_ID_PATH_PLACEHOLDER: ':employeeId',
  FORM_ID_PATH_PLACEHOLDER: ':formId',
}
